import api from "../../../api/stock/_produits";

export default {
    getListeArticles() {
        return new Promise((resolve, reject) => {
            api.getListeArticles().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getVentesExterne(data) {
        return new Promise((resolve, reject) => {
            api.getVentesExterne(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeConsommables() {
        return new Promise((resolve, reject) => {
            api.getListeConsommables().then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getListeMedicamentsParCategorie(data){
        return new Promise((resolve,reject) => {
            api.getListeMedicamentsParCategorie(data).then(
                response => {
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },
}